<app-content *ngIf='applicationInfo() as applicationInfo'>
  <app-breadcrumbs>
    <li>
      <a routerLink='/e-uslugi'>E-usługi</a>
    </li>
    <li>
      {{ applicationInfo?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <h2>
      {{ applicationInfo?.name }}
    </h2>
  </section>
  @if (applicationInfo.content; as content) {
    <div [innerHTML]='content'></div>
  }
  <br>
  <div class='d-flex justify-content-end'>
    @if(authed) {
      @if (completedData) {
        <a class='btn btn-primary' routerLink='skladanie-wniosku'>
          Przejdź do złożenia wniosku
        </a>
      } @else {
        <app-alert [closable]="false">
          Przejdź do złożenia wniosku" niech wyświetla się komunikat "Aby złożyć wniosek, należy wcześniej zaakceptować regulamin oraz wyrazić zgodę na przetwarzanie danych osobowych (RODO) w sekcji:
          <a routerLink="/moje-dane"><strong>Moje dane.</strong></a>
        </app-alert>
      }
    } @else {
      <a class='btn btn-primary' routerLink='/goto-login-gov'>
        Zaloguj się aby przejść do formularza
      </a>
    }
  </div>
</app-content>
